import { DocumentReference, FirestoreDataConverter } from 'firebase/firestore';
import { omitBy } from 'lodash';
import moment from 'moment';
import Aceite from '../models/aceite';
import BaseDb from './baseDb';
import toFirestore from './toFirestore';
import TermoDb from './termoAceiteDb';
import VersaoTermoDb from './versaoTermoDb';

export default class AceiteDb extends BaseDb<Aceite, { usuarioId: string; aceiteId: string }> {
  _path: string = 'usuarios/usuarioId/aceites/aceiteId';

  getConverter(): FirestoreDataConverter<Aceite> {
    return {
      fromFirestore: (snapshot) =>
        new Aceite({
          ref: snapshot.ref.withConverter(this.getConverter()),
          dataAceite: moment(snapshot.get('dataAceite').toDate()),
          termo: (snapshot.get('termo') as DocumentReference).withConverter(new TermoDb().getConverter()),
          versao: (snapshot.get('versao') as DocumentReference).withConverter(new VersaoTermoDb().getConverter()),
          hash: snapshot.get('hash'),
        }),
      toFirestore: (aceite: Aceite) => toFirestore(omitBy(aceite, ['ref'])),
    };
  }
}
